export default "__VITE_ASSET__CsY$tsrO__"